




































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FakeAsset extends Vue {
  @Prop({default: 'OK'}) public positiveActionLabel!: string[];
  @Prop() public merchant!: string;

  public actionClick(positiveAction: boolean) {
    this.$emit('onActionClick', positiveAction);
  }

  get fakeAssetText() {
    if (this.merchant === 'tenaga') {
      return 'Unable to match credentials.';
    } else {
      return 'Unable to validate product. If this problem persists, drop us an email at support@luxtag.io.';
    }
  }
}
